import './utils/ie11-polyfills';
import './utils/aria-toggle';
import './utils/is-in-viewport';


// Menu Controls
import mainNavInit from './component-controls/main-nav';
import mobileNav from './component-controls/mobile-nav';
import accessibleMenu from './component-controls/accessible-menu';
import general from "./component-controls/general";
//import general from "./component-controls/piechart";

// Component Controls
import accordionControls from './component-controls/accordion';
import alertBar from "./component-controls/alert-bar";
import slidersInit from './component-controls/slider';
//import postFeed from './component-controls/post-feed';
//import gallery from './component-controls/gallery';
import made_by from './utils/made-by';
import videoEmbeds from "./component-controls/video-embed";


// Global Utils
///import scrollToTop from './utils/scroll-to-top';
//import componentFadeIn from './animation/component-fade-in';
import search from './component-controls/search';
import alert from './component-controls/alert';


document.addEventListener('DOMContentLoaded', function () {
    accessibleMenu();
    mainNavInit();
    mobileNav();
    search();
    general();
    //piechart();
    //alert();
	alertBar();
    videoEmbeds();
    //scrollToTop();
    accordionControls();
    slidersInit();
    //componentFadeIn();
    //made_by();
    //postFeed();
    //gallery();
});
console.log('global.js loaded');